.icon-light {
    color: var(--grey-lt);
}

.icon-dark {
    color: var(--grey);
}
